import { createContext } from 'react';

export type ChipVariant = 'fill' | 'outline';

interface ChipContextProps {
    variant: ChipVariant;
}

const ChipContext = createContext<ChipContextProps>({} as ChipContextProps);

export default ChipContext;
